import React from 'react'
import PropTypes from 'prop-types'
import { Row, FlexCol } from 'components/patterns/Layout'
import { DIGITAL_INPUT } from 'utils/constants'

import {
  InputOperatorEditor,
  InputValueEditor,
  InputConfigEditor,
  EdgeEditor,
  InputCustomDescription,
} from './base'

const DigitalInputEditor = ({
  uri,
  isLogicSet,
  disableFalseValue,
  signal,
  inputConfig,
  floatingCircuit,
  outputConfig,
  fnId,
  customDescription,
  inputUri,
}) => (
  <>
    <InputCustomDescription
      uri={uri}
      inputUri={inputUri || signal}
      customDescription={customDescription}
      subType={DIGITAL_INPUT}
    />
    <Row align="top">
      <FlexCol className="editor-column" span={12}>
        <InputOperatorEditor
          uri={uri}
          fnId={fnId}
          outputConfig={outputConfig}
        />
      </FlexCol>
    </Row>

    <Row>
      <FlexCol className="editor-column" span={24}>
        <InputConfigEditor
          uri={uri}
          fixedDataType={DIGITAL_INPUT}
          signalUri={signal}
          floatingCircuit={floatingCircuit}
          inputConfig={inputConfig}
          fnId={fnId}
        />
      </FlexCol>
    </Row>
    <InputValueEditor uri={uri} disableFalseValue={disableFalseValue} />
    {isLogicSet && <EdgeEditor uri={uri} />}
  </>
)

DigitalInputEditor.defaultProps = {
  disableFalseValue: false,
}

DigitalInputEditor.propTypes = {
  uri: PropTypes.string,
  isLogicSet: PropTypes.bool,
  disableFalseValue: PropTypes.bool,
  signal: PropTypes.string,
  floatingCircuit: PropTypes.string,
  inputConfig: PropTypes.string,
  outputConfig: PropTypes.string,
  fnId: PropTypes.string,
  customDescription: PropTypes.string,
  inputUri: PropTypes.string,
}

export default DigitalInputEditor
